import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ɵInternalFormsSharedModule } from '@angular/forms';
import { DocumentManagementService } from 'src/framework/services/manage-doc.service';
import { SelectItemGroup, SelectItem, TreeNode } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { ManageDocComponent } from '../manage-doc/manage-doc.component';
import { LabelcardMgmtService } from 'src/framework/services/labelcard-mgmt.service';
import { error } from 'protractor';
import { TopicCardService } from 'src/framework/services/topic-card.service';
import { LogoIconMgmtService } from 'src/framework/services/logo-icon-mgmt.service';
import { ImageType } from '../../../enums/image-type';
import { environment } from '../../../../environments/environment';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';
import { LanguageService } from 'src/framework/services/language.service';
import { FolderManagementService } from 'src/framework/services/folder-mgmt.service';

@Component({
  selector: 'app-add-new-topic-card',
  templateUrl: './add-new-topic-card.component.html',
  styleUrls: ['./add-new-topic-card.component.css']
})
export class AddNewTopicCardComponent implements OnInit {
  processedDocIdLists: any[];


  @Input() set docLanguageId(newLimit: number) {
    this.docLanguageIds(newLimit);
  }
  @Input() docFolderId: string;
  @Output() emitDocument = new EventEmitter<any>();
  @ViewChild("ctrlFileUpload") ctrlFileUpload: ElementRef;


  allowedFileTypes: string;
  dataArray=[];
  environments=environment.ApplicationUrl+"/api/Document/download?docId=";
  calendarYearRange: string;
  pUpload: any;
  secondaryTopicCards = [];
  tempArray = [];
  menuindex=0;
  submenuIndex=0;
  menuItems = [];
  docTypeList: any[] = [];
  docCategoryList: any[] = [];
  languageName="EN"
  environmentsNew="Hello";
  docInfo = '';
  imageType = ImageType;
  showEditor = false;
  engagementDocList = [];
  docuDescription = ""
  selectedDoc: any;
  selectedCategory={'topicCardCategoryDescription':'Primary','topicCardCategoryId':1};
  selectedTypes  ={'topicCardTypeDescription':'TopicCard','topicCardTypeId':1};  
  selctedDocLanguageId = 1;
  selectedTopic: any;
  selectedType: TopicCardTypes;
  docDateDesc = 'Document Date';
  authorizerList: SelectItemGroup[] = [
    {
      label: 'Owners',
      items: [
        { label: 'Sharon Hamilton (sharon.s.hamilton@ca.ey.com)', value: 'CA010K54094' }
      ]
    },
    {
      label: 'Reviewers',
      items: [
        { label: 'Andrew Tuck (andrew.s.tuck@ca.ey.com)', value: 'CA010K54094' },
      ]
    },
    {
      label: 'PPAP',
      items: [
        { label: 'Mark Anthony (mark.anthony@ca.ey.com)', value: 'CA010K54094' },

      ]
    },
    {
      label: 'Sr. Managers',
      items: [
        { label: 'Ella Chuck (ella.chuck@ca.ey.com)', value: 'CA010K54094' },

      ]
    },
    {
      label: 'Admin',
      items: [
        { label: 'Nathan Fry (nathan.s.fry@ca.ey.com)', value: 'CA010K54094' },

      ]
    }


  ];

  engagementDetail = {
    appLanguage: 1,
    engagementId: 1,
    engagementName: '',
    engStatusId: 1,
    engStatusName: '',
    engInitialDate: null,
    engLanguage: [{
      "languageId": 1,
      "languageName": "English",
      "languageFlagPath": "../../assets/flags/English.png"
    }],
    engLanguageFrench: [{
      "languageId": 1,
      "languageName": "Anglaise",
      "languageFlagPath": "../../assets/flags/English.png"
    }]
  }

  documentForm: FormGroup;
  formSubmitted = false;
  showDateMandatory: boolean = false;
  appLangList: any[] = [];
  icons: any[] = [];
  iconsselected: SelectItem[];
  approvedEngagementDocList: any[] = [];
  selectedicons: any;
  isSortApplay = false;
  tinyMceConfig: any;
  selectedAppLanguage: any;
  selectedAppLanguageJson: any;
  defaultEnglishJson: any;
  selectedLangDocTypeJson: any;
  defaultEngDocTypeJson: any;
  selectedGlobalLanguageJson: any;
  defaultGlobalEnglishJson:any
  islabelLoaded: boolean = false;
  selectedLangDateJson: any;
  defaultEngDateJson: any;
  targetTreeData=[];
  localeSetting: any;
  filter = [{
    templateVariableName: 'foo'
  },
  {
    templateVariableName: 'noo'
  }
  ];

  constructor(private formBuilder: FormBuilder,private folderService: FolderManagementService,
    private manageTopicCardService: TopicCardService, private spinner: NgxSpinnerService, private manageDocService: DocumentManagementService,
    private labelCardService: LabelcardMgmtService, private logoIconMgmtService: LogoIconMgmtService, private languageService: LanguageService) {
    this.selectedType = new TopicCardTypes(1, '', '', new Date(), '', '');
    this.allowedFileTypes = ".doc,.docx,.dot,.jpg,.jpeg,.png,.tif,.pdf,.xls,.xlsx,.xlsb,.txt,.csv";
    this.calendarYearRange = (new Date().getUTCFullYear() - 10) + ':' + (new Date().getUTCFullYear() + 1);
  }

  ngOnInit(): void {
    this.loadLanguageLabel();

    // let sessionEngObj = JSON.parse(sessionStorage.getItem('engagementData'));
    // this.engagementDetail.engagementId = sessionEngObj['engagementId'];
    this.initializeEngagementData();
    this.buildForm();
    this.getEngagementApprovedDocument();
    this.setDocDateValidators();
    this.getTopicCardType();
    this.getTopicCardCategory();
    this.getEngagementDoc();
    this.getEngagementTopicCard();
    this.getLogoList();
    
  }


  
  sortNode(node: TreeNode) {

    if (!('sortTypeId' in node?.data[0])) {
      node.data[0]['sortTypeId'] = '2';
    }

    if (node?.data[0]?.sortTypeId.toString() === '1') {
      // node.draggable = false;
      // node.droppable = false;

      if (node.children) {
        //node?.children?.sort((a, b) => a.label?.localeCompare(b.label));
        node?.children?.sort((a, b) => this.displayFolderLabel(a).localeCompare(this.displayFolderLabel(b)));


      }
    }
    else if (node?.data[0]?.sortTypeId.toString() === '2') {
      // node.draggable = false;
      // node.droppable = false;

      if (node.children) {
        //node?.children?.sort((a, b) => a.label?.localeCompare(b.label));
        node?.children?.sort((a, b) => this.displayFolderLabel(a).localeCompare(this.displayFolderLabel(b)));
        node?.children?.sort(this.folder_date_sort_desc);

      }
    }
    else if (node?.data[0]?.sortTypeId.toString() === '3') {

    }
    else if (node?.data[0]?.sortTypeId.toString() === '4') {

      //node?.children?.sort((a, b) => b.label?.localeCompare(a.label));
      node?.children?.sort((a, b) => this.displayFolderLabel(b).localeCompare(this.displayFolderLabel(a)));
      node?.children?.sort((a, b) => this.folder_date_sort_desc(a, b));

    }
  }

  
  folder_date_sort_desc = function (a, b) {
    // This is a comparison function that will result in dates being sorted in
    // DESCENDING order.
    let res;
    if (a?.type?.toLowerCase() === 'file') {
      a = new Date(a?.data[0]?.documentDate).getTime() ?? new Date(a?.data[0]?.createdDTTM).getTime();
    }
    else {
      a = new Date(a?.data[0]?.createdDTTM).getTime();
    }

    if (b?.type?.toLowerCase() === 'file') {
      b = new Date(b?.data[0]?.documentDate).getTime() ?? new Date(b?.data[0]?.createdDTTM).getTime();
    }
    else {
      b = new Date(b?.data[0]?.createdDTTM).getTime();
    }

    res = a > b ? -1 : a < b ? 1 : 0;

    return res;

  }

  displayFolderLabel(node: TreeNode): string {
    let primaryLangId, otherPrimaryLangId = 0;
    let nodeLangList: any[] = [];
    let langIndex = -1;
    let folderLabel = '';
    if (node != null && node != undefined) {

      if (this.engagementDetail.appLanguage == 2) {
        primaryLangId = 2;
        otherPrimaryLangId = 1;
      }
      else //default is english
      {
        primaryLangId = 1;
        otherPrimaryLangId = 2;
      }

      folderLabel = node.label;
      nodeLangList = node?.data[0]?.language;

      if (nodeLangList?.length > 0) {
        if ((langIndex = nodeLangList.findIndex(x => Number(x.languageId) === Number(primaryLangId))) > -1) {
          if (nodeLangList[langIndex]?.folderName?.trim() !== ''
            && nodeLangList[langIndex]?.folderName !== null
            && nodeLangList[langIndex]?.folderName !== undefined) {
            folderLabel = nodeLangList[langIndex]?.folderName;
          }
          else {
            if ((langIndex = nodeLangList.findIndex(x => Number(x.languageId) === Number(otherPrimaryLangId))) > -1) {
              if (nodeLangList[langIndex]?.folderName?.trim() !== ''
                && nodeLangList[langIndex]?.folderName !== null
                && nodeLangList[langIndex]?.folderName !== undefined) {
                folderLabel = nodeLangList[langIndex]?.folderName;
              }
            }
          }
        }
      }
    }
    return folderLabel;

  }


  getFolderStructure() {
    this.spinner.show();
    this.folderService.getFolderTemplate(this.engagementDetail.engagementId).then(files => {
      if (files && files.length > 0) {

        var count: Array<number>=[];
        if (files.length > 0 && files[0].children) {
          let i =0;
          files[0].children.forEach(childNode => {
          if(childNode.label==undefined)
          {
            count.push(i);
          }
          i = i+1;
        });
        }
        
        count.forEach( val =>{
          files[0].children.pop(files[0].children[val]);
        });
        
        let x = this.removeEmptyFolder(files[0])
        x['label'] = "Public Documents"
        this.targetTreeData = x ? x.children.filter(t => t.styleClass != 'detailhideFileClass') : []
        if(!this.isSortApplay)
        {
         this.targetTreeData.forEach(x => {
           if (x.type.toLowerCase() === 'folder') {
             this.sortNode(x);
           }
         });
        }
        // this.targetTreeData = files.length > 0 ? files : []
        // this.preProcessTree();
      }
      this.configureTinyMce();
      this.showEditor = true;
      this.spinner.hide();
    });
  }

  preProcessTree(editor,environments,lanName) {


      this.tempArray=[];
      this.menuItems=[];
      this.targetTreeData.forEach(x => {
        this.preProcessTreeRecursive(x,editor,environments,lanName)
      });
      var newArray=[];

      var indexArray=Object.keys(this.menuItems);
      indexArray.forEach((item,index)=>{
        newArray[index]=this.menuItems[item];
      });
      return newArray;

  }

  

  preProcessTreeRecursive(node: any,editor,environments,lanName) {
    if (node != null && node != undefined) {
      if (node.type.toLowerCase() === 'file') {
        if(node.data[0]['parentId']==0){
          var docId = node.data[0].docId;
          this.menuItems.push(
            {
              type:'menuitem',
              text:node.label,
              id:node.key,
              
              onAction: function () {
                editor.insertContent("<a class='document' target='_blank' href="+environments+docId+"&language="+lanName+" >" + node.label + "</a>");        // editor.dom.add(editor.getBody(), 'div', {class: 'row'}, this.getColMd12(f));
              }
            }
          );
        }
          else{
            var nodes =this.findNode(node.data[0]['parentId']);
            var menuNodes = this.findMenuNode(node.data[0]['parentId']);
            var oldArrays=[];
            if(this.menuItems[node.data[0]['parentId']]){
              var docId = node.data[0].docId;
            oldArrays= this.menuItems[node.data[0]['parentId']].fetches;

            oldArrays.push({
              
              type:'menuitem',
              text:node.label,
              id:node.key,
              onAction: function () {
                editor.insertContent("<a class='document' target='_blank' href="+environments+docId+"&language="+lanName+" >" + node.label + "</a>");    
              }
            });

            this.menuItems[node.data[0]['parentId']].fetches=oldArrays;
            
            this.menuItems[node.data[0]['parentId']].getSubmenuItems=function(){return oldArrays;
            }
            }
            else{
              oldArrays= menuNodes.fetches;
            //   var prevArrays = this.menuItems[nodes['folderId']].fetches;
            //   var arrays = prevArrays.filter(item=>item.text===nodes.label);
            //  oldArrays = arrays[0].fetches;
            //  var parentIndex = prevArrays.indexOf(arrays[0]);
             var docId = node.data[0].docId;

             oldArrays.push({
              
              type:'menuitem',
              text:node.label,
              id:node.key,
              onAction: function () {
                editor.insertContent("<a class='document' target='_blank' href="+environments+docId+"&language="+lanName+" >" + node.label + "</a>");    
              }
            });

            menuNodes.fetches=oldArrays;
            menuNodes.getSubmenuItems=function(){return oldArrays;}
            
            }
            
           


          
          }
        }
      else if (node.type.toLowerCase() === 'folder') {
        if(node.children.length>0){

        if(node.hasOwnProperty('folderId')){
          var menuNodes = this.findMenuNode(node['folderId']);
          var menuArrays=[];
          var indexArrays=Object.keys(this.menuItems);
          indexArrays.forEach((item,index)=>{
            menuArrays[index]={...this.menuItems[item]};
          });
          //var trees= this.filterData(menuArrays,node['folderId']);
          var oldfolderArrays= menuNodes.fetches;

          oldfolderArrays.push({
            
            type:'nestedmenuitem',
            text:node.label,
            id:node.key,
            fetches:[],
            getSubmenuItems: function () {
            }
          });

          menuNodes.getSubmenuItems=function(){return oldfolderArrays;}

          // if(this.menuItems[node['folderId']]){
          
          // this.menuItems[node['folderId']].fetches=oldfolderArrays;
          
          // this.menuItems[node['folderId']].getSubmenuItems=function(){return oldfolderArrays;
          // }
          // }
          // else if(this.menuItems[trees[0].id]){
          //  var newItems= this.menuItems[trees[0].id].fetches.filter(item=>item.id===node['folderId'])
          //  if(newItems.length>0){
          //  newItems[0].fetches = oldfolderArrays;
          //  newItems[0].getSubmenuItems=function(){return oldfolderArrays;}
          //  }
          //  else if(this.menuItems[trees[0].id])
          // }

        }
        else{
          this.menuItems[node.key]={
            type:'nestedmenuitem',
            text: node.label,
            id:node.key,
            fetches:[],
            folderfetches:[],
            getSubmenuItems: function(){

            }
          };
        }
      }

      }
      if (node.children) {
        node.children.forEach(childNode => {
          this.preProcessTreeRecursive(childNode,editor,environments,lanName);
        });
      }
    }
  }



  findNode(nodeKey): TreeNode {
    var found = false;
    let foundNode: TreeNode = {};

    function recurseFindParent(searchTree) {

      for (var i = 0; i < searchTree.length; i++) {

        // Found the category!
        if (Number(searchTree[i].key) === Number(nodeKey)) {
          foundNode = searchTree[i];
          found = true;
          break;

          // Did not match...
        } else {
          // Are there children / sub-categories? YES
          // if(searchTree[i].children !== ''){
          if (searchTree[i].children.length > 0) {
            recurseFindParent(searchTree[i].children);
            if (found) {
              break;
            }
          }
          //}
        }
      }
    }

    recurseFindParent(this.targetTreeData);

    return foundNode;
  }


 filterData(data:any, id) {
   var that=this;
    var r = data.filter(function(o) {
      if (o.fetches.length>0) 
      {
        o.fetches = that.filterData(o.fetches, id);
      }
      return o.id != id
    })
    return r;
  }


  
  findMenuNode(nodeKey): any {
    var found = false;
    let foundNode: any = {};

    function recurseFindParent(searchTree) {
      

      for (var i = 0; i < searchTree.length; i++) {
        if(searchTree[i]){

        // Found the category!
        if (Number(searchTree[i].id) === Number(nodeKey)) {
          foundNode = searchTree[i];
          found = true;
          break;

          // Did not match...
        } else {
          // Are there children / sub-categories? YES
          // if(searchTree[i].children !== ''){
          if (searchTree[i].fetches&&searchTree[i].fetches.length > 0) {
            recurseFindParent(searchTree[i].fetches);
            if (found) {
              break;
            }
          }
          //}
        }
      }
      }
    }

    recurseFindParent(this.menuItems);

    return foundNode;
  }
  

  removeEmptyFolder(node: any) {

    let primaryLangId, otherPrimaryLangId, secondPrimaryLangId, thirdPrimaryLangId, fourthPrimaryLangId, fifthPrimaryLangId = 0;

    if (this.engagementDetail.appLanguage == 2) {
      primaryLangId = 2;
      otherPrimaryLangId = 1;
    }
    else if (this.engagementDetail.appLanguage == 1) {
      primaryLangId = 1;
      otherPrimaryLangId = 2;
    }
    else if (this.engagementDetail.appLanguage == 3) {
      primaryLangId = 3;
      otherPrimaryLangId = 1;
      secondPrimaryLangId = 2;
    }

    else //default is english
    {
      primaryLangId = 1;
      otherPrimaryLangId = 2;
    }
    let isValidFolder = false;
    for (let i = 0; i < node.children.length; i++) {
      if (node.children[i].type == 'folder') {
        this.sortNode(node);
        if(node.type=='folder'){
        node.children[i]['folderId']=node.key;
        }
        if (this.removeEmptyFolder(node.children[i]).styleClass != 'detailhideFileClass') {
          isValidFolder = true;
        }
      } else if (node.children[i].type == 'file') {
        if (this.approvedEngagementDocList && this.approvedEngagementDocList.length > 0) {
          let res = this.approvedEngagementDocList.find(x => x.docId == node.children[i].data[0].docId && x.docVersionId == node.children[i].data[0].docVersionId && primaryLangId == node.children[i].data[0].languageId)
          if (res == null || res == undefined)
            res = this.approvedEngagementDocList.find(x => x.docId == node.children[i].data[0].docId && x.docVersionId == node.children[i].data[0].docVersionId && otherPrimaryLangId == node.children[i].data[0].languageId)
          if (res == null || res == undefined)
            res = this.approvedEngagementDocList.find(x => x.docId == node.children[i].data[0].docId && x.docVersionId == node.children[i].data[0].docVersionId && secondPrimaryLangId == node.children[i].data[0].languageId)
          if (res) {
            node.children[i].styleClass = 'fileClass';
            node.children[i]['description'] = res.documentDescription;
            node.children[i]['docId'] = res.docId
            node.children[i]['documentDate'] = res.documentDate
            isValidFolder = true;
          } else {
            node.children[i].styleClass = 'detailhideFileClass';

          }
        }
      }
    }
    if (node.type == "folder" && !isValidFolder) {
      node.styleClass = 'detailhideFileClass';
    }
    return node;
  }
  
    




  docLanguageIds(limit: number) {
    this.selctedDocLanguageId = limit;
    if(this.selctedDocLanguageId==1){
        this.languageName="EN";
    }
    else{
      this.languageName="FR";
    }
  }


  getEngagementApprovedDocument() {
      this.engagementDetail['statusName']=this.engagementDetail.engStatusName;
      this.manageDocService.getEngagementApprovedDocument(this.engagementDetail).subscribe(res => {
        if (res) {
          //success
          this.approvedEngagementDocList = res.data;
          this.getFolderStructure();
        } else {
          //display error
        }
    });
  }



  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishglobalLanguageMappings, selectedglobalLanguageMappings: any;

    let englishDateMappings, selectedLangDateMappings: any;

    return new Promise((resolve, reject) => {
      this.spinner.show();
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedAppLanguage = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.selectedAppLanguage = data.Id
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.TopicCards.toLowerCase()
            && Number(item?.languageId) === 1)[0];

            englishglobalLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
              && Number(item?.languageId) === 1)[0];
          englishDateMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
            && Number(item?.languageId) === 1)[0];


          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.TopicCards.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];


              selectedglobalLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];   

            selectedLangDateMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

          }
          else {
            if (Number(this.selectedAppLanguage) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.TopicCards.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];


                selectedglobalLanguageMappings = languageMappings.filter(item =>
                  item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
                  && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangDateMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedglobalLanguageMappings = englishglobalLanguageMappings;

              selectedLangDateMappings = englishDateMappings;

            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings?.languageMappingJSON ?? englishLanguageMappings.languageMappingJSON);
          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON ?? englishDateMappings.languageMappingJSON);
          this.defaultEngDateJson = JSON.parse(englishDateMappings.languageMappingJSON);

          this.selectedGlobalLanguageJson = JSON.parse(selectedglobalLanguageMappings.languageMappingJSON);
          this.defaultGlobalEnglishJson = JSON.parse(englishglobalLanguageMappings.languageMappingJSON);


          this.setCalendarLocale();
          this.docDateDesc = this.labelReplacer('txtDocDate');
          this.islabelLoaded = true;
          this.spinner.hide();
          resolve(1);
        }
        else {
          this.spinner.hide();
        }
      });
    })
      .catch(err => {
        this.spinner.hide();

        console.log(err);
      });
  }




  labelReplacer(labelKey): string {
    let value;
    value = this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
    return value;
  }

  calendarReplacer(labelKey): string {
    return this.selectedLangDateJson[labelKey]?.trim() ? this.selectedLangDateJson[labelKey] ?? 'text not found' : this.defaultEngDateJson[labelKey] ?? 'text not found';
  }

  dayOrMonthNameShort(name, length): string {
    let shortName = '';
    if (name?.trim()?.length == 0)
      shortName = 'Text not found';
    else if (name?.trim()?.length > 0 && name?.trim()?.length < length)
      shortName = name;
    else
      shortName = name.substr(0, length);
    return shortName;
  }

  setCalendarLocale() {
    this.localeSetting = {
      firstDayOfWeek: 0,
      dayNames: [
        this.calendarReplacer("SUN"),
        this.calendarReplacer("MON"), this.calendarReplacer("TUE"), this.calendarReplacer("WED"),
        this.calendarReplacer("THU"), this.calendarReplacer("FRI"), this.calendarReplacer("SAT")
      ],
      dayNamesShort: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 3), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 3), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 3),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 3), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 3)
      ],
      dayNamesMin: [
        this.dayOrMonthNameShort(this.calendarReplacer("SUN"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("MON"), 1), this.dayOrMonthNameShort(this.calendarReplacer("TUE"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("WED"), 1), this.dayOrMonthNameShort(this.calendarReplacer("THU"), 1),
        this.dayOrMonthNameShort(this.calendarReplacer("FRI"), 1), this.dayOrMonthNameShort(this.calendarReplacer("SAT"), 1)
      ],
      monthNames: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
      ],
      monthNamesShort: [
        this.calendarReplacer("JAN"), this.calendarReplacer("FEB"), this.calendarReplacer("MAR"),
        this.calendarReplacer("APR"), this.calendarReplacer("MAY"), this.calendarReplacer("JUN"),
        this.calendarReplacer("JUL"), this.calendarReplacer("AUG"), this.calendarReplacer("SEP"),
        this.calendarReplacer("OCT"), this.calendarReplacer("NOV"), this.calendarReplacer("DEC")
        ],
      today: this.calendarReplacer('TODAY'),
      clear: this.calendarReplacer('CLEAR')
    }
  }



  typesReplacer(labelKey): string {
    return  this.selectedGlobalLanguageJson[labelKey]?.trim() ? this.selectedGlobalLanguageJson[labelKey] ?? 'text not found' : this.defaultGlobalEnglishJson[labelKey] ?? 'text not found';
  }
  
  initializeEngagementData() {

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('appLanguageList')) {
        this.appLangList = JSON.parse(sessionStorage.getItem('appLanguageList'));
      }
      else {
        this.getLanguageList();
      }

      if (sessionStorage.getItem('engagementDetail')) {
        this.engagementDetail = JSON.parse(sessionStorage.getItem('engagementDetail'));
        const minYear =
          Number(new Date().getUTCFullYear() - 10) <
            Number(new Date(this.engagementDetail?.engInitialDate).getUTCFullYear()) ?
            Number(new Date().getUTCFullYear() - 10) :
            Number(new Date(this.engagementDetail?.engInitialDate).getUTCFullYear());

        this.calendarYearRange = minYear + ':' + (new Date().getUTCFullYear() + 1);
      }
      resolve(1);
    });
  }


  buildForm() {

    this.documentForm = this.formBuilder.group({
      docTitle: ['', Validators.required],
      docDescription: ['',Validators.required],
      docType: ['', Validators.required],
      docCategory: ['',],
      docDate: ['', Validators.required],
      authorizer: [''],
      docIcon: ['']
    });

  }

  configureTinyMce() {
    const that = this;
    this.tinyMceConfig = {
      branding: false,
      toolbar_mode: 'sliding',
      toolbar_sticky: false,
      inline: false,
      statusbar: false,
      theme: "silver",
      resize: false,
      skin: "oxide",
      skin_url: 'assets/skins/ui/oxide',
      base_url: '/tinymce',  
      suffix: '.min'   ,
      plugins: [
        "print preview   importcss autoresize contextmenu searchreplace autolink autosave save directionality  visualblocks visualchars fullscreen image link media  template codesample table charmap hr pagebreak nonbreaking anchor  insertdatetime advlist lists  wordcount  textpattern noneditable help code charmap  emoticons paste "],
      menubar: 'edit insert view  format table tools help',
      force_br_newlines: false,
     
      allow_script_urls: true,
      relative_urls : false,
      remove_script_host : false,
      entity_encoding : "raw",
    
      // content_css: [
      //   '//fonts.googleapis.com/css?family=EYFontRegular',
      // ],
      paste_as_text: true,
      paste_text_sticky: true,
      font_formats: 'EYFontRegular=EYFontRegular;',
      theme_advanced_fonts: "EYFontRegular=EYFontRegular",
      extended_valid_elements: "@[id|class|title|style|onmouseover|onclick]," +
        "a[name|href|target|title|alt]," +
        "#div,blockquote,-ol,-ul,-li,br,img[src|height|width],-sub,-sup,-b,-i,-u," +
        "-span[data-mce-type],hr,",
      toolbar: 'document topicCard | bold italic backcolor | ' +
        'bullist numlist outdent indent | alignright alignjustify |' +
        '   alignleft aligncenter | removeformat |' +
        ' help ',
      setup: function (editor) {

        const topictest = that.secondaryTopicCards.map(f => {
          return {
            type: 'menuitem',
            text: f.label,
            onAction: function () {
              editor.insertContent("<a class='topicCard'  href='javascript:void(0);' onclick='Window.myComponent.openTopics(" + f.value + ")'>" + f.label + "</a>");        // editor.dom.add(editor.getBody(), 'div', {class: 'row'}, this.getColMd12(f));
              //editor.setContent('<a (click)="openTopicCard('+f.value+')"><p>'+f.label+'</p></a>');
            }
          };
        });


        editor.ui.registry.addMenuButton('document', {
          text: 'Document',
          fetch: function (callback) { 
            callback(that.preProcessTree(editor,that.environments,that.languageName));
          }
        });



        editor.ui.registry.addMenuButton('topicCard', {
          text: 'Topic Cards',
          fetch: function (callback) {
            callback(topictest);
          }
        });
      }
    };
  }


  



  //get inner element 'col-md-6'
  getColMd6(values) {
    var html = "";
    html += '<a (click)="Window.myComponent.openTopicCard(' + values.value + ')"><p>' + values.label + '</p></a>';
    return html;
  }

  //get inner element 'col-md-12'
  //  getColMd12(number){
  //   var html = "";
  //   for(var i = 0; i < number; i++){
  //       html += '<div class="col-md-12"></div>';
  //   }
  //   return html;
  // }

  //Last parameter lets you specify extra inner html




  getLogoList() {
    this.spinner.show();
    this.iconsselected = [];
    this.logoIconMgmtService.getLogoIconList().subscribe((response) => {
      if (response && response.data?.length > 0) {


        var iconList = response.data.filter(item => item.imageTypeId === this.imageType.Icon);
        if (iconList.length > 0) {
          iconList.forEach(item => {
            item.url = 'data:image/png;base64,' + item.result;
          })
        }
      }

      iconList.forEach(item => {
        this.iconsselected.push(
          {
            'label': item.imageLink,
            'value': item.logoIconImageDataId,
            'icon': item.url
          }
        )
      });
      this.icons = iconList
      this.spinner.hide();
    });
  }

  linkDoc(event) {
    this.docuDescription = this.docuDescription + '<a href=doc-' + event.value.docId + '><p>' + event.value.documentTitle + '</p></a>';
  }

  linkTopic(event) {
    this.docuDescription = this.docuDescription + '<a href=topicCard-' + event.value.topicCardId + '><p>' + event.value.tctitle + '</p></a>';
  }

  getTopicCardType() {
    this.manageTopicCardService.getTopicCardType().subscribe(res => {
      if (res) {
        //success
        this.docTypeList = res.data;
        this.docTypeList.forEach(item=>{
          item.topicCardTypeDescription=this.typesReplacer(item.topicCardTypeDescription);
        })
      } else {
        //display error
      }

    });
  }

  getEngagementDoc() {
    return new Promise((resolve, reject) => {
      this.manageDocService.getEngagementDocument(this.engagementDetail).subscribe(res => {
        if (res) {
          //success
          if (res.data && res.data.length > 0 && this.engagementDocList.length == 0) {
            res.data.forEach(item => {
              item.documentVersionList.forEach(element => {
                if (element.languageId == this.selctedDocLanguageId&& element.currentAuthorized==true) {
                  this.engagementDocList.push({ 'label': element.documentTitle, 'value': element.docId });
                }
              });
            });
          }
          else {
            this.engagementDocList = [];
          }
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }


  getEngagementTopicCard() {
    return new Promise((resolve, reject) => {
      this.manageTopicCardService.getEngagementTopicCard(this.engagementDetail).subscribe(res => {
        if (res) {
          this.secondaryTopicCards = [];
          //success
          var topicCards = res.data;
          topicCards.forEach(item => {
            if (item.topicCardTypeId == 1) {
              if (item.topicCardCategoryId == 2) {
                item.topicCardVersionList.forEach(element => {
                  if (element.languageId == this.selctedDocLanguageId && element.currentAuthorized==true) {
                    this.secondaryTopicCards.push({ 'label': element.tctitle, 'value': element.topicCardId });
                  }
                });

              }
            }
          });
          
          
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }

  getTopicCardCategory() {
    this.manageTopicCardService.getTopicCardCategory().subscribe(res => {
      if (res) {
        //success
        this.docCategoryList = res.data;
        this.docCategoryList.forEach(item=>{
          item.topicCardCategoryDescription=this.typesReplacer(item.topicCardCategoryDescription);
        })
      } else {
        //display error
      }

    });
  }


  getLanguageList() {
    return new Promise((resolve, reject) => {
      this.labelCardService.getLanguageList().subscribe(res => {
        if (res) {
          //success
          // this.appLangList = res;
          res.forEach(element => {
            if (element.isAppLanguage) {
              this.appLangList.push({
                languageId: element.languageId,
                languageName: element.name,
                languageFlagPath: element.languagePath
              });
            }

          });
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }

  setDocDateValidators() {
    const docDateControl = this.documentForm.get('docDate');

    this.documentForm.get('docType').valueChanges
      .subscribe(docTypeValue => {

        if (docTypeValue) {
          if (docTypeValue.documentTypeId === 1) {
            docDateControl.setValidators([Validators.required]);
            this.showDateMandatory = true;
          }
          else if (docTypeValue.documentTypeId === 2) {
            docDateControl.setValidators(null);
            this.showDateMandatory = false;
          }

          this.docDateDesc = docTypeValue.descriptionOfDate;
          if (docTypeValue.preferredNamingConvention && docTypeValue.preferredNamingConvention != '')
            this.docInfo += ' ,File Naming Convention: ' + docTypeValue.preferredNamingConvention;

        }


        docDateControl.updateValueAndValidity();

      });

  }

  saveDocument() {
    return new Promise((resolve, reject) => {

      this.spinner.show();
      this.formSubmitted = true;

      // stop here if form is invalid
      if (this.documentForm.invalid) {
        this.spinner.hide();
        return;
      }
      else {
        if (this.documentForm.value["docCategory"] == "") {
          this.documentForm.value["docCategory"] = { "topicCardCategoryId": null }
        }
        let documentData = {
          ...this.documentForm.value,
          'engagementId': this.engagementDetail.engagementId,
          'languageId': this.selctedDocLanguageId,
          'topicCardId': 0,
          'topicCardVersionId': 0,
          'statusId': 1,
          'documentDate': (this.documentForm.controls['docDate']?.value == null || 
          this.documentForm.controls['docDate']?.value == undefined || 
          this.documentForm.controls['docDate']?.value == '') ?  null : new Date(this.documentForm.controls['docDate'].value).toDateString(),

        }

        const formData = new FormData();

        formData.append('fileJson', JSON.stringify(documentData));

        this.manageTopicCardService.uploadNewTopicCard(formData).subscribe(res => {
          if (res.status === 0) {
            //success
            this.resetForm();
            if (res.data) {
              this.emitDocument.emit(res?.data);
            }
            resolve(1);

          } else {
            //display error
            this.resetForm();
            reject();
          }
          this.spinner.hide();

        });

      }
    })
      .catch(error => {
        console.log(error);
        this.spinner.hide();
      })

  }

  onUpload(event) {
    for (let file of event.files) {
      this.pUpload = file;
    }
  }

  resetForm() {
    this.formSubmitted = false;
    this.documentForm.controls['docTitle'].setValue('');
    this.documentForm.controls['docDescription'].setValue('');
    this.documentForm.controls['docType'].setValue('');
    this.documentForm.controls['docCategory'].setValue('');
    this.documentForm.controls['docDate'].setValue('');
    this.documentForm.controls['authorizer'].setValue('');
    this.documentForm.controls['docIcon'].setValue('');
    this.selectedTopic = "";
    this.selectedDoc = "";
    this.pUpload = null;
    this.docInfo = '';
    this.docDateDesc = 'Document Date';
  }

  onFileRemove(event) {
    this.pUpload = null;
  }


}

export class TopicCardTypes {
  topicCardTypeId: number;
  topicCardTypeDescription: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: any;
  constructor(topicCardCategoryId: number, topicCardCategoryDescription: string, createdBy: string, createdDate: Date, modifiedBy: any, modifiedDate: any) {
    this.topicCardTypeId = topicCardCategoryId;
    this.topicCardTypeDescription = topicCardCategoryDescription;
    this.CreatedBy = createdBy;
    this.CreatedDate = createdDate;
    this.ModifiedBy = modifiedBy;
    this.ModifiedDate = modifiedDate;
  }
}
